import React, { useRef, useState, useEffect } from "react";
const PDFUpload = ({ onChangeContent }) => {
  const [content, setContent] = useState(null);
  const pdfButton = useRef();
  useEffect(() => {
    if (content) onChangeContent(content);
  }, [content]);
  const selectFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      setContent(content);
    }
  };
  return (
    <React.Fragment>
      <div className="col-12">
        <label htmlFor="image">Upload PDF &nbsp; </label>
        <input
          ref={pdfButton}
          type="file"
          id="pdf"
          name="pdf"
          accept="application/pdf"
          className="form-control-file"
          style={{ display: "none" }}
          onChange={selectFile}
        />
        <button
          className="btn btn-green"
          onClick={() => pdfButton.current.click()}
        >
          Choose PDF
        </button>
      </div>
    </React.Fragment>
  );
};
export default PDFUpload;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/PDFUpload.js